import React from "react";
import configData from "config/config.json";
import { Link } from "react-router-dom";

export const getChallengeTableColumns = (params?: any) => {
  return [
    {
      id: "cmsTitle",
      label: "CMS Title",
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
      renderCell: (row: any) => row?.cmsTitle || "—",
    },
    {
      id: "type",
      label: "Type",
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "copiedFrom",
      label: `Copied From`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
      renderCell: (row: any) => {
        const id = row?.copiedFrom;
        if (!id || id === "-") return "-";

        const url = configData.routes.challenges.editChallenges.replace(":id", id);

        return React.createElement(
          Link,
          {
            to: url,
            target: "_blank",
            onClick: (e: any) => e.stopPropagation(),
            style: {
              color: "#007bff",
              textDecoration: "underline",
              cursor: "pointer",
              opacity: 1,
            },
          },
          id,
        );
      },
    },
    {
      id: "tier",
      label: "Tier",
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "objectiveType",
      label: "Objective",
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "objectiveTarget",
      label: "Target",
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "rewardType",
      label: "Reward Type",
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "rewardValue",
      label: "Reward Value",
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "startDateText",
      label: "Start Date",
      type: "date",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "endDateText",
      label: "End Date",
      type: "date",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "scheduleType",
      label: "Schedule",
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "territoriesText",
      label: "Territories",
      type: "string",
      isSortable: false,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "isActiveText",
      label: "Status",
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    { id: "actions", label: "Actions" },
  ];
};
